import { Col, Row, Image } from 'react-bootstrap';

interface Props {
  children: any;
}

export const CreateAccountLayout = (props: Props) => {
    return (
<div className="container-fluid p-0">
        <Row className="register-form vh-100 vw-100 g-0 overflow-hidden p-0 m-0 ">
         <Col
            xs={0}
            md={5}
            className="h-100 d-none d-md-flex flex-wrap justify-content-center align-items-center background-login"
            onClick={() => window.open('https://gradmap.com', '_blank')}
            style={{ cursor: 'pointer' }}
          >
            <Image
              alt="GradMap logo"
              src="/assets/images/login-logo-blue.png"
              className="login-logo"
            />
          </Col>
          <Col xs={12} md={0} className="d-none d-md-none p-0">
            <Image alt="GradMap logo" src="/assets/images/Topbar.png" width="100%" />
          </Col>
          <Col xs={12} md={7} className="d-flex flex-column justify-content-evenly align-items-center">            
            {props.children}
          </Col>
    
    <style scoped>{`
    .background-login {
      background-image: url("/assets/images/bg-login.png");
      background-size: cover;
    }
    iframe#userpilot-checklist {
      display: none !important;
    }
    `}</style>
        </Row>
</div>
      );    
}


export const ValueSectionColumn = () => {
  return (
    <div id="value-section" className="d-none d-md-block col-md-6 bg-gradient-to-br from-blue-600 to-blue-700">
       <div className="flex items-center justify-center p-12">
          <div className="max-w-md">
            <div className="mb-8">
              <h1 className="text-3xl font-bold text-white mb-2">GradMap</h1>
              <p className="text-blue-100 text-lg">Your pathway to summer programs</p>
            </div>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="text-white" data-fa-i2svg=""><svg className="svg-inline--fa fa-bookmark" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bookmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"></path></svg></i></div>
                <div>
                  <h3 className="text-white font-semibold text-lg mb-1">Save programs
                  </h3>
                  <p className="text-blue-100">Bookmark interesting summer programs and keep them organized in one place</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="text-white" data-fa-i2svg=""><svg className="svg-inline--fa fa-calendar-check" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="calendar-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"></path></svg></i></div>
                <div>
                  <h3 className="text-white font-semibold text-lg mb-1">Track
                    deadlines</h3>
                  <p className="text-blue-100">Never miss an application deadline with our smart reminder system</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="text-white" data-fa-i2svg=""><svg className="svg-inline--fa fa-list-check" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="list-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"></path></svg></i></div>
                <div>
                  <h3 className="text-white font-semibold text-lg mb-1">Organize applications</h3>
                  <p className="text-blue-100">Streamline your application process with our tracking tools</p>
                </div>
              </div>
            </div>
            <div className="mt-12 p-6 bg-blue-500/20 rounded-lg border border-blue-400/30">
              <div className="flex items-center space-x-3 mb-3">
                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                  <i className="text-blue-600 text-sm" data-fa-i2svg=""><svg className="svg-inline--fa fa-star" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" data-fa-i2svg=""><path fill="currentColor" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"></path></svg></i></div>
                <span className="text-white font-semibold">Join 10,000+ students</span>
              </div>
              <p className="text-blue-100 text-sm">"GradMap helped me organize my summer program applications and I got into my dream program!" - Sarah M.</p>
            </div>
          </div>
      </div>
    </div>        
  )
}